export default {
  billList: {
    column: {
      collectBillSerialNumber: '应收票据流水号',
      payBillSerialNumber: '应付票据流水号',
      billSerialNumber: '票据流水号',
      billCompanyCode: '公司',
      collectBillCode: '应收票据号',
      payBillCode: '应付票据号',
      billCode: '票据号',
      billProperty: '票据性质',
      billCategory: '票据类型',
      billAmount: '票面金额',
      billStatus: '票据状态',
      customerName: '客户',
      billTakeDepartmentName: '收票部门',
      payBillTakeDepartmentNo: '开票部门',
      expiringDate: '到期日',
      collectBillMakerName: '开票人',
      payBillMakerName: '出票人',
      collectBillMakeDate: '开票日期',
      payBillMakeDate: '出票日期',
      collectBillMakeBankName: '承兑行',
      payBillMakeBankName: '出票人银行',
      payBillMakeBankAccount: '出票人账号',
      arrivalBankAccount: '入账银行账号',
      arrivalBranchName: '入账银行',
      collectBillTakerName: '收票人',
      payBillTakerName: '收款人',
      billTakeDate: '收票日期',
      collectBillTakeBankName: '收票银行',
      payBillTakeBankName: '收款人银行',
      payBillTakeBankAccount: '收款人账号',
      isPledge: '是否质押',
      discountDate: '贴现日期',
      discountCharge: '贴现息',
      discountIncomeAmount: '贴现所得金额',
      billBookValue: '贴现票据账面价值',
      endorseDate: '背书日期',
      endorseDepartmentNo: '背书部门',
      collectionDate: '托收日期',
      pledgeDate: '质押日期',
      billRecorderName: '录入人',
      billRecordDate: '录入日期',
      acceptorName: '承兑人',
      acceptBankAccount: '承兑人账号',
      acceptBankName: '承兑人银行',
      acceptBankBranchNo: '承兑人银行行号',
      isAssignment: '能否转让',
      accountingStatus: '保证金入账状态',
      marginAmount: '保证金金额',
      paymentAccountingStatus: '解付入账状态',
    },
    message: {
      noCopy: '只有贴现类型为部门贴公司不贴的情况下才可以复制！',
      cancel: '撤销数据？',
      noSelected: '您还未选择任何数据!',
      noSelectData: '请至少选择一条数据进行操作',
      onlyOneSelectData: '请选择一条数据进行操作',
      onlyRegeist: '只有已登记的票据才可编辑！',
      noExport: '当前没有数据可以导出！',
      noCanDelSelectData: '所选数据中不符合要求（需要已登记状态），请重新选择！',
      noCanCancelSelectData: '所选数据中没有已冲销的财务凭证，请先冲销或请重新选择！',
      hasCannotDelTip: '所选数据中有不可删除的数据，点击确认只会删除已登记状态的数据！',
      hasCannotCancelTip: '所选数据中有不可撤销的数据，点击确认只会删除已已冲销的财务凭证！',
    },
    status: {
      yes: '是',
      no: '否',
      pledge: '质押',
      noPledge: '未质押',
      assignment: '转让',
      noAssignment: '非转让',
    },
  },
};
